import isUrlFromIsUrl from 'is-url';
import { URL_PATTERN } from './../../app/shared/constants/constants';

export function removeQueryParameter(url?: string): string {
    if (url == null) {
        return '';
    }
    if (url.indexOf('?') > -1) {
        return url.split('?')[0];
    }
    return url;
}

// This function is used as an adapter for the is-url dependency so that it can be easily replaced.
export function isUrl(url: string): boolean {
    return isUrlFromIsUrl(url);
}

export function isHttpOrHttpsUrl(url: string): boolean {
    return new RegExp(URL_PATTERN).test(url);
}
